"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWishlistQuery = void 0;
class GetWishlistQuery {
    constructor(userId) {
        this.userId = userId;
    }
}
exports.GetWishlistQuery = GetWishlistQuery;
